export const keys = {
    all: ["alarmlynx-summary"],
    summaryDatas: () => [
        ...keys.all,
        "summary-data"
    ],
    summaryData: (groupID: number) => [
        ...keys.summaryDatas(),
        {
            groupID
        }
    ]
};
